import { Component, OnInit, HostListener } from '@angular/core';
import { CWSMSAPIService } from '../cwsmsapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatMenuTrigger, MatIconRegistry } from '@angular/material';
import { BuyCreditsComponent } from '../buy-credits/buy-credits.component';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css']
})
export class AdminDashboardComponent implements OnInit {
	errorMessage: string = "";
	messageCredits: number = 0;
	sidemenuOpen: boolean = true;
	screenHeight: number;
	screenWidth: number;
	billingInfo: any = {};
	loading: boolean = false;

	constructor(public cwsms: CWSMSAPIService, public router: Router, private route: ActivatedRoute) {
		this.onResize();
	}

	ngOnInit() {
	}

	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		console.log(this.screenWidth+"x"+this.screenHeight);

		if (this.screenWidth < 720) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	toggleSidemenu() {
		if (this.sidemenuOpen) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	receivedSideMenuEvent(event) {
		if ("userData" in event) {
			this.messageCredits = parseFloat(event.userData.credits.N);
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/admin-dashboard.component.ts